var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhotoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 636.9 578",
    enableBackground: "new 0 0 636.9 578",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M17.3,468.6c9.2,19.4,21.9,37.3,38.4,53.7C92.8,559.4,137.5,578,190,578h256.9c52.5,0,97.3-18.5,134.4-55.7  c2.7-2.7,5.3-5.4,7.8-8.2L453.6,382c-6.6-6.1-13.2-6.3-19.8-0.5l-78,74.8l-13.5,12.3l-7-7c-1.7-1.1-3.3-2.6-4.7-4.7L182.4,276.1  L17.3,468.6 M581.3,55.7C544.2,18.6,499.4,0,446.9,0H190C137.5,0,92.8,18.6,55.7,55.7C18.5,92.7,0,137.5,0,190v190.1l132.8-155.1  c36.7-39,71-40,102.9-2.9l118.2,147L399,324c7.3-10,14.8-17.5,22.5-22.6l25.4-25.4l33,32.9c5,4.2,10,9.2,15,15.1l130.6,130.5  c7.6-20.6,11.4-42.8,11.4-66.5V190C636.9,137.5,618.4,92.7,581.3,55.7 M447,145.9c14.4,0,26.6,5.1,36.8,15.2  c10.2,10.2,15.2,22.4,15.2,36.8c0,14.4-5.1,26.6-15.2,36.8c-10.1,10.2-22.4,15.2-36.8,15.2s-26.6-5.1-36.8-15.2  c-10.1-10.1-15.2-22.4-15.2-36.8c0-14.4,5.1-26.6,15.2-36.8C420.4,151,432.6,145.9,447,145.9z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoIcon);
export default __webpack_public_path__ + "static/media/photo_icon.efa647e2.svg";
export { ForwardRef as ReactComponent };